import React from 'react';
import cn from 'classnames';

import styles from './Circle.module.css';

const Circle = ({ text, animate }) => (
  <li
    className={cn('flex flex-col items-center', styles.listItem, {
      [`${styles.animate}`]: animate
    })}
  >
    <div className={`${styles.circleWrapper} w-12 h-12 relative mb-4`}>
      {animate && (
        <svg
          className={`${styles.svg} w-full h-full opacity-0 absolute inset-0 z-10`}
          viewBox="0 0 40 40"
        >
          <path
            d="M40 20C40 31.0353 31.0353 40 20 40C8.96471 40 0 31.0353 0 20C0 8.96471 8.96471 0 20 0C31.0353 0 40 8.96471 40 20ZM31.2 10.8706C30.5412 10.3294 29.6 10.3765 28.9647 10.8941L28.9412 10.8706L16.0471 21.6L10.8941 18.1882C10.3294 17.8118 9.55294 17.7882 8.94118 18.1882C8.14118 18.7294 7.90588 19.8353 8.44706 20.6353L13.3412 27.9765C14.4235 29.6 16.6118 30.0471 18.2353 28.9647C18.5176 28.7765 18.7529 28.5412 18.9647 28.2824L31.3882 13.3647C32.0471 12.6118 31.9529 11.5059 31.2 10.8706Z"
            fill="#DD45D3"
          />
        </svg>
      )}
    </div>
    <p className={`${styles.text} text-sm text-black`}>{text}</p>
  </li>
);

export default Circle;
